import { Navigate, useParams } from 'react-router';

/** `/h/:hid` alone always means the month checklist (docs/03 §4.4). */
export function HouseholdIndexRedirect() {
  const { hid } = useParams<{ hid: string }>();
  return <Navigate to={`/h/${hid}/month`} replace />;
}
